import { render, staticRenderFns } from "./BgSelectRelationModalView.vue?vue&type=template&id=2917b3a1"
import script from "./BgSelectRelationModalView.vue?vue&type=script&lang=js"
export * from "./BgSelectRelationModalView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports